import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
} from "helpers/api_helper"
import {
  ADD_INGREDIENT,
  DELETE_INGREDIENT,
  GET_ALL_INGREDIENTS,
  GET_ALL_INGREDIENTS_LIST,
  GET_INGREDIENT_DETAILS,
  UPDATE_INGREDIENT,
  UPDATE_INGREDIENT_STATUS,
} from "helpers/url_helper"

export const getIngredientsList = createAsyncThunk(
  GET_ALL_INGREDIENTS_LIST,
  async payload => {
    const response = await get(GET_ALL_INGREDIENTS_LIST, payload)
    return response
  }
)

export const getIngredients = createAsyncThunk(
  GET_ALL_INGREDIENTS,
  async payload => {
    const response = await post(GET_ALL_INGREDIENTS, payload)
    return response
  }
)

export const updateIngredientStatus = createAsyncThunk(
  UPDATE_INGREDIENT_STATUS,
  async payload => {
    const response = await patch(UPDATE_INGREDIENT_STATUS, payload)
    return response
  }
)

export const deleteIngredient = createAsyncThunk(
  DELETE_INGREDIENT,
  async payload => {
    const response = await del(DELETE_INGREDIENT, payload)
    return response
  }
)

export const addIngredient = createAsyncThunk(ADD_INGREDIENT, async payload => {
  const response = await formDataPost(ADD_INGREDIENT, payload)
  return response
})

export const getIngredientDetails = createAsyncThunk(
  GET_INGREDIENT_DETAILS,
  async payload => {
    const response = await post(GET_INGREDIENT_DETAILS, payload)
    return response
  }
)

export const updateIngredient = createAsyncThunk(
  UPDATE_INGREDIENT,
  async payload => {
    const response = await formDataPut(UPDATE_INGREDIENT, payload)
    return response
  }
)
